/**
 * buildInfo.ts
 *
 * Build identification for client-side telemetry.
 *
 * Bump `BUILD_MARKER` on every deploy that touches the post composer /
 * Lexical editor so that a freeze or error report tells us exactly which
 * build the reporting client was running. Keep it a plain string literal
 * (no dynamic date/env computation) so it stays stable within a single
 * deployed build.
 */

export const BUILD_MARKER = '2026-09-28-perf-instrumentation';
